export default __webpack_public_path__ + "static/media/main-app-blue-(orig).f7c3c3ab.png";